/**
 * URL parameter names for filtering and sorting
 */
export const FILTER_PARAMS = {
  QUERY: 'q',
  SORT_BY: 'sort_by',
};

/**
 * Default sort options
 */
export const SORT_OPTIONS = {
  MANUAL: 'manual',
  RELEVANCE: 'relevance',
};

/**
 * Search query constants
 */
export const SEARCH_CONSTANTS = {
  EMPTY_QUERY: '',
};
